import React, { FC, useContext } from 'react';

import { Separator, Toggle } from '@smartshell/ui-kit';

import { TimeOutInput } from 'components';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const Refund: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <>
      <Toggle
        onChange={(value: string) =>
          setSetting({
            alias: ESettingsAliases.REFUNDS,
            value: value ? '1' : '0',
          })
        }
        value={settings.isRefundEnabled}
        label={t('setting.refund')}
        description={t('settings.billing.work.payment.description')}
        variant="secondary"
        emptyBg
      />
      <Separator style={{ margin: '16px 0' }} />
      <TimeOutInput
        label={t('setting.refund.headroom')}
        description={t('settings.billing.work.time.description')}
        setting={settings.refundHeadroom}
        updateSetting={setSetting}
        settingAlias={ESettingsAliases.REFUNDS_HEADROOM}
        maxMinutes={720}
        disabled={settings.isRefundEnabled}
      />
    </>
  );
};
